import * as React from 'react';
import { withStyles, Theme, createStyles, WithStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import { UsersAPI, APIError, APIErrorType, User } from 'src/api';
import strings from 'src/strings';
import KDGlobal from '../Global';
import { defaultView, DefaultView } from '../HOC';
import Header from '../Header/Header';
import { Switch, Route, Redirect } from 'react-router';
import Settings from '../Settings/Settings';
import Client from '../Client/Client';
import Report from '../Report/ReportCopy';
import { AgencyReport } from '../AgencyReport/AgencyReport';

interface DashboardProps extends WithStyles<typeof styles>, DefaultView<true> {

}

interface DashboardState {
    loading: boolean;
    user: User
}

class Dashboard extends React.Component<DashboardProps, DashboardState> {

    constructor(props: DashboardProps) {
        super(props);
        this.state = {
            loading: false,
            user: this.props.user
        }
    }

    componentDidMount() {
        this.setState({ loading: true })
        if (sessionStorage.getItem('subscribed') == 'true') {
            this.props.showToast('success', strings.checkout_subscriptionSuccess)
            sessionStorage.removeItem('subscribed')
        } else if (sessionStorage.getItem('loggedIn') == 'true') {
            this.props.showToast('success', strings.welcomeBack)
            sessionStorage.removeItem('loggedIn')
        } else if (sessionStorage.getItem('signUp') == 'true') {
            this.props.showToast('success', strings.sign_up_welcome)
            sessionStorage.removeItem('signUp')
        } else if (sessionStorage.getItem('cancelMembership') == 'true') {
            this.props.showToast('success', strings.cancel_sucess)
            sessionStorage.removeItem('cancelMembership')
        }

        UsersAPI.getMe().then(user => {
            this.setState({ loading: false })
            KDGlobal.instance.setUser(user, undefined)
            if (!user.verified) {
                this.props.history.push('/verify')
            } else {
                this.setState({ user: user })
            }
        }).catch((err: APIError) => {
            return
            KDGlobal.instance.unsetUser()
            if (err.type == APIErrorType.MissingAuthorizationError || err.type == APIErrorType.SessionNotFoundError) {
                this.props.history.push({
                    pathname: '/login',
                    state: {
                        message: {
                            type: 'warning',
                            message: strings.error_loginExpired
                        }
                    }
                })
            } else {
                this.props.history.push({
                    pathname: '/login',
                    state: {
                        message: {
                            type: 'error',
                            message: strings.error_generic
                        }
                    }
                })
            }
        })
    }

    public render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <CssBaseline />
                <Header user={this.state.user} loading={this.state.loading} />
                <main className={classes.content}>
                    <div className={classes.appBarSpacer} />
                    <Switch>
                        <Route path='/app/settings' component={Settings} />
                        <Route path='/app/clients' component={Client} />
                        <Route path='/app/reports' component={Report} />
                        <Route path='/app/agency-report' render={(props) => {
                            return <AgencyReport accountid={this.props.user.account.id} />
                        }} />
                        <Route path='/app/dashboard' render={(props) => {
                            return <Redirect to='/app/reports' />
                        }} />
                    </Switch>
                </main>
            </div>
        )
    }
}

const styles = (theme: Theme) => createStyles({
    root: {
        display: 'flex',
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        height: '100vh',
        overflow: 'auto',
    },
});

export default defaultView(withStyles(styles)(Dashboard), true) as React.ComponentClass;


// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.tsx